import React from 'react'
import { Router } from '@reach/router'
import { BodyText, Container, Row, Col } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
//utils
import { APP_URL } from './constants/constants'
import serverData from './utils/server-data'
import Layout from './components/Layout'
const Home = React.lazy(() => import('./screens/home'))

function App() {
  const routeHome = APP_URL,
    { selectedComponent, isMerchantUser } = serverData,
    privacyHubclass = ['privacyhub', 'privacyhub2'].includes(selectedComponent)
      ? 'app-privacyhub_home'
      : ''

  return (
    <Layout>
      <Container
        fluid={true}
        className={isMerchantUser && 'merchant-fluid-container'}
        data-testid="home-page"
      >
        <Row>
          <Col lg={12} className={privacyHubclass}>
            <React.Suspense
              fallback={
                <BodyText>
                  <Message id="app.suspense.fallbackText" />
                </BodyText>
              }
            >
              <Router basepath={serverData.requestURI}>
                <Home path="/privacyhub/*" />
                <Home path="/merchant" />
                <Home path="/data/verify/*" />
                <Home path="/settings/*" />
                <Home path={routeHome} />
                <Home path="/zettle/*" />
                <Home path="/retrigger-sms/*" />
                <Home path="/common/*" />
              </Router>
            </React.Suspense>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default App
